var React = require('react');

function Location (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.998 1.82c.41 0 .82.032 1.225.093 3.973.584 6.852 4.126 6.643 8.173-.167 4.914-4.215 8.423-6.613 10.077a2.177 2.177 0 0 1-1.242.386c-.467 0-.924-.145-1.308-.414-2.457-1.702-6.578-5.313-6.578-10.366C1.13 5.38 4.652 1.825 8.998 1.82zm0-1.135C4.028.685 0 4.752 0 9.769c0 5.572 4.423 9.47 7.067 11.303a3.41 3.41 0 0 0 1.944.613c.67 0 1.324-.203 1.876-.584 2.583-1.782 6.919-5.564 7.103-10.976.217-4.62-3.068-8.655-7.6-9.334A9.29 9.29 0 0 0 8.998.685zm0 5.677c1.863 0 3.374 1.525 3.374 3.407 0 1.881-1.51 3.406-3.374 3.406S5.624 11.65 5.624 9.77c.002-1.88 1.511-3.405 3.374-3.407zm0-1.135c-2.485 0-4.499 2.033-4.499 4.542 0 2.508 2.014 4.542 4.499 4.542s4.499-2.034 4.499-4.542c0-2.509-2.014-4.542-4.5-4.542z","fill":"#F0626D"}));
}

Location.defaultProps = {"width":"18","height":"22"};

module.exports = Location;

Location.default = Location;
